<template>
  <div style="text-align: center;width: 1350px;margin: 0 auto;">
    <el-collapse v-model="activeName" accordion>
      <el-collapse-item title="白车身柔性生产线" name="1">
        <product-one></product-one>
      </el-collapse-item>
      <el-collapse-item title="机器人集成系统" name="2">
        <product-two></product-two>
      </el-collapse-item>
      <el-collapse-item title="涂装、总装输送系统" name="3">
        <product-three></product-three>
      </el-collapse-item>
      <el-collapse-item title="各类设备及装配线" name="4">
        <product-four></product-four>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
    import productOne from './Components/product_01'
    import productTwo from './Components/product_02'
    import productThree from './Components/product_03'
    import productFour from './Components/product_04'

    export default {
        data() {
            return {
                activeName: '1'
            };
        },
        components: {
            productOne,
            productTwo,
            productThree,
            productFour
        }
    }
</script>

<style scoped>
  .el-collapse {
    margin: 25px 50px 0;
  }

  .el-collapse >>> .el-collapse-item__header {
    height: 50px;
    padding-left: 35px;
    border-bottom: 1px solid #d3d3d3;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
    line-height: 50px;
    font-size: 18px;
    letter-spacing: 3px;
  }

  .el-collapse >>> .el-collapse-item__header.is-active {
    color: #0f59a4;
  }

  .el-collapse >>> .el-collapse-item__wrap {
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
  }

  .el-collapse >>> .el-collapse-item__content{
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Product/productShow.vue